import { GamgeeChatMessageRead } from '~/types/message';


export default function SentBubble({ message }: { message: GamgeeChatMessageRead }) {
  return (
    <div className="chat chat-end">
      <div className="chat-bubble">
        {message.message.content}
      </div>
    </div>
  );
}
